// src/PagamentoModal.js

import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, Button, Select, MenuItem, FormControl, InputLabel,
  Grid, IconButton, Box, Typography, Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { toast } from 'react-toastify';

const PagamentoModal = ({ open, reserva, onClose, onSave }) => {
  // --- Estados para o primeiro adiantamento ---
  const [metodoAdiantamento1, setMetodoAdiantamento1] = useState('');
  const [valorAdiantamento1, setValorAdiantamento1] = useState(0);
  const [dataAdiantamento1, setDataAdiantamento1] = useState(null);

  // --- NOVOS ESTADOS PARA O SEGUNDO ADIANTAMENTO ---
  const [metodoAdiantamento2, setMetodoAdiantamento2] = useState('');
  const [valorAdiantamento2, setValorAdiantamento2] = useState(0);
  const [dataAdiantamento2, setDataAdiantamento2] = useState(null);

  const [metodoPagamentoRestante, setMetodoPagamentoRestante] = useState('');
  const [valorPagamentoRestante, setValorPagamentoRestante] = useState(0);
  const [dataPagamentoRestante, setDataPagamentoRestante] = useState(null);
  
  const [desconto, setDesconto] = useState(0);
  const [motivoDesconto, setMotivoDesconto] = useState('');

  useEffect(() => {
    dayjs.locale('pt-br'); 
    if (reserva) {
      setMetodoAdiantamento1(reserva.adiantamento?.metodo || '');
      setValorAdiantamento1(reserva.adiantamento?.valor || 0);
      setDataAdiantamento1(reserva.adiantamento?.data ? dayjs(reserva.adiantamento.data) : null);

      setMetodoAdiantamento2(reserva.adiantamento2?.metodo || '');
      setValorAdiantamento2(reserva.adiantamento2?.valor || 0);
      setDataAdiantamento2(reserva.adiantamento2?.data ? dayjs(reserva.adiantamento2.data) : null);

      setMetodoPagamentoRestante(reserva.pagamentoRestante?.metodo || '');
      setValorPagamentoRestante(reserva.pagamentoRestante?.valor || 0);
      setDataPagamentoRestante(reserva.pagamentoRestante?.data ? dayjs(reserva.pagamentoRestante.data) : null);

      setDesconto(reserva.desconto || 0);
      setMotivoDesconto(reserva.motivoDesconto || '');
    }
  }, [reserva]);
  
  if (!reserva) {
    return null;
  }

  const handleSave = () => {
    if ((parseFloat(desconto) || 0) > 0 && !motivoDesconto.trim()) {
        toast.error('O motivo do desconto é obrigatório.');
        return;
    }

    const dadosPagamento = {
      adiantamento: {
        metodo: metodoAdiantamento1,
        valor: parseFloat(valorAdiantamento1) || 0,
        data: dataAdiantamento1 ? dataAdiantamento1.format('YYYY-MM-DD') : null,
      },
      adiantamento2: {
        metodo: metodoAdiantamento2,
        valor: parseFloat(valorAdiantamento2) || 0,
        data: dataAdiantamento2 ? dataAdiantamento2.format('YYYY-MM-DD') : null,
      },
      pagamentoRestante: {
        metodo: metodoPagamentoRestante,
        valor: parseFloat(valorPagamentoRestante) || 0,
        data: dataPagamentoRestante ? dataPagamentoRestante.format('YYYY-MM-DD') : null,
      },
      desconto: parseFloat(desconto) || 0,
      motivoDesconto: motivoDesconto,
    };
    onSave(dadosPagamento);
    onClose();
  };

  const saldoDevedor = (reserva?.valorTotalComExtras || 0) - (parseFloat(desconto) || 0) - (parseFloat(valorAdiantamento1) || 0) - (parseFloat(valorAdiantamento2) || 0) - (parseFloat(valorPagamentoRestante) || 0);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Gestão de Pagamentos
          <IconButton onClick={onClose}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>1º Adiantamento (Sinal)</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}><TextField label="Valor do 1º Adiantamento" type="number" fullWidth value={valorAdiantamento1} onChange={(e) => setValorAdiantamento1(e.target.value)} /></Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Método</InputLabel>
                  <Select value={metodoAdiantamento1} label="Método" onChange={(e) => setMetodoAdiantamento1(e.target.value)}>
                    <MenuItem value="">Nenhum</MenuItem>
                    <MenuItem value="PIX">PIX</MenuItem>
                    <MenuItem value="Dinheiro">Dinheiro</MenuItem>
                    <MenuItem value="Cartão de Crédito">Cartão de Crédito</MenuItem>
                    <MenuItem value="Cartão de Débito">Cartão de Débito</MenuItem>
                    <MenuItem value="Transferência">Transferência</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}><DatePicker label="Data do 1º Adiantamento" value={dataAdiantamento1} onChange={(novaData) => setDataAdiantamento1(novaData)} /></Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            {/* --- NOVA SEÇÃO PARA O 2º ADIANTAMENTO --- */}
            <Typography variant="h6" gutterBottom>2º Adiantamento (Sinal)</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}><TextField label="Valor do 2º Adiantamento" type="number" fullWidth value={valorAdiantamento2} onChange={(e) => setValorAdiantamento2(e.target.value)} /></Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Método</InputLabel>
                  <Select value={metodoAdiantamento2} label="Método" onChange={(e) => setMetodoAdiantamento2(e.target.value)}>
                     <MenuItem value="">Nenhum</MenuItem>
                    <MenuItem value="PIX">PIX</MenuItem>
                    <MenuItem value="Dinheiro">Dinheiro</MenuItem>
                    <MenuItem value="Cartão de Crédito">Cartão de Crédito</MenuItem>
                    <MenuItem value="Cartão de Débito">Cartão de Débito</MenuItem>
                    <MenuItem value="Transferência">Transferência</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}><DatePicker label="Data do 2º Adiantamento" value={dataAdiantamento2} onChange={(novaData) => setDataAdiantamento2(novaData)} /></Grid>
            </Grid>
            
            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" gutterBottom>Pagamento Final</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}><TextField label="Valor do Pagamento Final" type="number" fullWidth value={valorPagamentoRestante} onChange={(e) => setValorPagamentoRestante(e.target.value)} /></Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Método</InputLabel>
                  <Select value={metodoPagamentoRestante} label="Método" onChange={(e) => setMetodoPagamentoRestante(e.target.value)}>
                    <MenuItem value="">Nenhum</MenuItem>
                    <MenuItem value="PIX">PIX</MenuItem>
                    <MenuItem value="Dinheiro">Dinheiro</MenuItem>
                    <MenuItem value="Cartão de Crédito">Cartão de Crédito</MenuItem>
                    <MenuItem value="Cartão de Débito">Cartão de Débito</MenuItem>
                    <MenuItem value="Transferência">Transferência</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}><DatePicker label="Data do Pagamento Final" value={dataPagamentoRestante} onChange={(novaData) => setDataPagamentoRestante(novaData)} /></Grid>
            </Grid>
            
            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" gutterBottom>Desconto</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}><TextField label="Valor do Desconto" type="number" fullWidth value={desconto} onChange={(e) => setDesconto(e.target.value)} /></Grid>
              <Grid item xs={12} sm={6}><TextField label="Motivo do Desconto" fullWidth value={motivoDesconto} onChange={(e) => setMotivoDesconto(e.target.value)} /></Grid>
            </Grid>

            <Box sx={{ mt: 3, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1, textAlign: 'center' }}>
                <Typography variant="body1">Saldo Devedor</Typography>
                <Typography variant="h5" color={saldoDevedor > 0 ? 'error.main' : 'success.main'}>
                    {saldoDevedor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </Typography>
            </Box>

          </Box>
        </DialogContent>
        <DialogActions sx={{ p: '16px 24px' }}>
          <Button onClick={onClose} variant="outlined">Cancelar</Button>
          <Button onClick={handleSave} variant="contained" color="primary">Salvar Pagamentos</Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default PagamentoModal;

